<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">My Job Requests</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-check-circle" label="Approve" iconPos="left"  class="p-button-success me-3"></button>
        <button pButton type="button" icon="pi pi-times-circle" label="Reject" iconPos="left" class="p-button-danger"></button>
    </div>
</div>

<div class="p-white shadow m-3">
<p-table [value]="products" responsiveLayout="scroll" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <div class="d-flex flex-row justify-content-between">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text"  placeholder="Search keyword" />
            </span>
            <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th  pSortableColumn="code">Code<p-sortIcon field="code"></p-sortIcon></th>
            <th>Name</th>
            <th>Category</th>
            <th>Quantity</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>{{product.code}}</td>
            <td>{{product.name}}</td>
            <td>{{product.category}}</td>
            <td>{{product.quantity}}</td>
        </tr>
    </ng-template>
</p-table>
</div>


